import { useAuth0 } from '@auth0/auth0-react'
import {
  useUpdateSingleProjectByUserAdmin,
  useGetSingleProjectByUserAdmin,
} from 'lib/react-query/queriesProject'
import { useQueryClient } from '@tanstack/react-query'
import React, { useCallback } from 'react'
import { useParams } from 'react-router-dom'
import ButtonOnOff from './ButtonOnOff'

const DisabledButton = () => {
  const { user } = useAuth0()
  const { idProject } = useParams()
  const queryClient = useQueryClient()
  const { mutateAsync: updateProject } = useUpdateSingleProjectByUserAdmin(
    user?.sub,
    idProject
  )
  const {
    data: projectData,
    isLoading,
    error,
  } = useGetSingleProjectByUserAdmin(user?.sub, idProject)

  const isDisabled = projectData?.data?.disabled ?? false
  const isDisabledClass = isDisabled ? '' : 'enabled'

  const handleToggle = async () => {
    try {
      await updateProject({
        body: {
          disabled: !isDisabled,
        },
      })
      queryClient.invalidateQueries({
        queryKey: ['projects-admin', user?.sub],
      })
    } catch (error) {
      console.error('Error al actualizar el estado del proyecto:', error)
      alert('No se pudo actualizar el estado del proyecto. Inténtalo de nuevo.')
    }
  }

  // Renderizado condicional dentro del JSX
  if (!user || !user.sub) {
    return <div>Usuario no autenticado</div>
  }

  if (!idProject) {
    return <div>No se encontró el ID del proyecto</div>
  }

  if (isLoading) {
    return <div>Cargando...</div>
  }

  if (error) {
    return <div>Error al cargar el proyecto: {error.message}</div>
  }

  return (
    <div className={`container2 ${isDisabledClass}`}>
      <span>
        <h2 className={`title2 ${isDisabledClass}`}>
          {isDisabled ? 'Proyecto Deshabilitado' : 'Proyecto habilitado'}
        </h2>
      </span>
      <br />
      <span>
        <p className={`text2 ${isDisabledClass}`}>
          {isDisabled
            ? 'Si habilitas este proyecto, cualquier usuario podrá acceder a este proyecto'
            : 'Si deshabilitas este proyecto, ningún usuario podrá acceder a este proyecto'}
        </p>
      </span>
      <br />
      <ButtonOnOff isOn={!isDisabled} onToggle={handleToggle} />
    </div>
  )
}

export default DisabledButton
